// Modal.tsx
import React, { useEffect, useState } from "react";
import { CheckoutForm } from "../../StripePayment";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { auth } from "../../../../firebase/firebase";
import { BASE_API_URL, STRIPE_PUBLIC_KEY } from "../../../../config";

//pk_test_51OKSMKLBVeE8UmykUG76gCXcuohFJvMDoBC4EKvFF8LWtDUqoUO1qubiSxE5xhQDKxkPrpnagcG7tJ7fyzduxixT00bThFSNt5
//pk_test_51JMS0KSBL7zJpZgVBe8LQ09PXd9bNVtI34NQQeTrynE3nGyV9mbW6D4CaSMH7N3JjjjVLp49eV36zHCzD5mY5Bum00A5Kw2kR8
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

// const options = {
//   mode: "payment",
//   amount: 1099,
//   currency: "usd",
//   appearance: {},
// };

interface ModalProps {
  isOpen: boolean;
  onPaymentDone: () => void;
}

const PaymentModal = ({ isOpen, onPaymentDone }: ModalProps) => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  const userId = auth.currentUser?.uid;
  useEffect(() => {
    //http://127.0.0.1:5001/skarvostore/us-central1
    //https://us-central1-skarvostore.cloudfunctions.net
    if (isOpen && userId) {
      fetch(`${BASE_API_URL}/create_payment_intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: 1000, currency: "usd", userId }),
      })
        .then(res => {
          console.log(res);
          return res.json();
        })
        .then(data => {
          console.log(data);
          setClientSecret(data.client_secret);
        })
        .catch(error => console.error("Error fetching clientSecret:", error));
    }
  }, [isOpen, userId]);

  if (!isOpen) return null;

  // const options = clientSecret ? { clientSecret } : undefined;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center h-full bg-black bg-opacity-50 w-fill">
      <div className="items-center content-center w-1/2 p-4 mx-auto text-center bg-white rounded-lg shadow-lg h-[600px]">
        {clientSecret ? (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <CheckoutForm clientSecret={clientSecret} />
          </Elements>
        ) : (
          // <>
          //   <h2 className="text-lg font-bold">Process Payment</h2>
          //   <button onClick={onPaymentDone} className="px-4 py-2 mt-4 text-white bg-green-500 rounded hover:bg-green-700">
          //     Done
          //   </button>
          // </>
          <>Loading...</>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;
